// supportData.js (create in ./data/supportData.js)
import * as Icons from '../public/icons/Supporticons';

export const supportData = {
  // Future Gifts Data (matches your screenshot exactly)
  'future-gifts': {
    icon: Icons.FutureGiftsIcon,
    title: 'Future Gifts Support',
    description: 'Everything you need to know about preparing, scheduling, and managing future gifts.',
    searchPlaceholder: 'Search orders, future gifts, memoirs, delivery, or payments',
    faqs: [
      {
        question: 'What is a Future Gift?',
        answer: 'A Future Gift is something you prepare now — like a digital memory, audio gift, or extra content — and schedule to be revealed or delivered later.'
      },
      {
        question: 'How does the QR code work?',
        answer: 'The QR code is visible immediately, but it only reveals the future gift on the scheduled date.'
      },
      {
        question: 'Can I edit my Future Gift later?',
        answer: 'You can update or add content anytime before the fulfillment date.'
      },
      {
        question: 'What happens if I forget to add content?',
        answer: 'If you forget to add content, the gift will still be delivered on the scheduled date with whatever content has been uploaded up to that point. You can add content anytime before the fulfillment date.'
      },
      {
        question: 'Can I have multiple Future Gifts in one box?',
        answer: 'Yes, you can bundle multiple Future Gifts in a single package. Each gift can have its own reveal date and content.'
      }
    ],
    relatedArticles: [
      {
        title: 'How to Schedule a Future Gift',
        description: 'Step-by-step guide to scheduling your Future Gift',
        link: '/blog/schedule-future-gift'
      },
      {
        title: 'QR Code Management',
        description: 'Everything about QR codes for Future Gifts',
        link: '/blog/qr-code-management'
      }
    ]
  },
  
  // Orders & Delivery Data
  'orders-delivery': {
    icon: Icons.OrderReceivedIcon,
    title: 'Orders & Delivery',
    description: 'Tracking, shipping, delivery dates, and issues.',
    faqs: [
      {
        question: 'How can I track my order?',
        answer: 'You can track your order using the tracking link provided in your shipping confirmation email.'
      },
      {
        question: 'What are your delivery times?',
        answer: 'Standard delivery takes 3-5 business days. Express delivery is available for 1-2 business days.'
      },
      {
        question: 'Can I change my shipping address?',
        answer: 'Yes, you can change your shipping address within 24 hours of placing your order.'
      }
    ]
  },
  
  // Frameworks Data
  'frameworks': {
    icon: Icons.FrameworksIcon,
    title: 'Frame it Forward',
    description: 'Gift boxes, add-ons, and future gifts.',
    faqs: [
      {
        question: 'What is Frame it Forward?',
        answer: 'Frame it Forward is our framework for creating and gifting meaningful memories that can be scheduled for future delivery.'
      },
      {
        question: 'How do gift boxes work?',
        answer: 'Gift boxes can contain multiple items and can be scheduled for delivery on specific dates.'
      }
    ]
  },
  
  // Memoirs Data
  'memoirs': {
    icon: Icons.MemoirsIcon,
    title: 'Memoirs',
    description: 'Creating, editing, and printing your memoir.',
    faqs: [
      {
        question: 'How do I create a memoir?',
        answer: 'You can create a memoir by uploading photos, adding text, and customizing the layout in our editor.'
      },
      {
        question: 'Can I edit my memoir after creating it?',
        answer: 'Yes, you can edit your memoir anytime before placing the print order.'
      }
    ]
  },
  
  // Refunds & Payments Data
  'refunds-payments': {
    icon: Icons.RefundIcon,
    title: 'Payment & Refund',
    description: 'Charges, discounts, refunds, and invoices.',
    faqs: [
      {
        question: 'What is your refund policy?',
        answer: 'We offer refunds within 30 days of purchase for unused digital products and unopened physical products.'
      },
      {
        question: 'How long do refunds take?',
        answer: 'Refunds typically take 5-10 business days to appear on your statement.'
      }
    ]
  },
  
  // Technical Issues Data
  'technical': {
    icon: Icons.TechnicalIssuesIcon,
    title: 'Technical Issues',
    description: 'Uploads, errors, account access.',
    faqs: [
      {
        question: 'What do I do if I cannot upload files?',
        answer: 'Check file size and format. We support JPG, PNG, PDF, and MP4 files up to 100MB.'
      },
      {
        question: 'How do I reset my password?',
        answer: 'Click "Forgot Password" on the login page and follow the instructions sent to your email.'
      }
    ]
  }
};

// Helper function to get support data by slug
export const getSupportData = (slug) => {
  return supportData[slug] || supportData['future-gifts']; // Default to future gifts if not found
};